"use client";

import React from "react";
import { SectionContentProps } from "../../types";
import EditableText from "../../core/EditableText";
import { PiArrowRight } from "react-icons/pi";

export default function CorporateHero({ content, onContentChange, isSelected }: SectionContentProps) {
  const fontFamily = content.fontFamily || "'Inter', sans-serif";
  const primaryColor = content.colorPalette?.primary || "#3B82F6";

  const updateContent = (key: string, value: any) => {
    onContentChange?.({ ...content, [key]: value });
  };

  return (
    <div
      className={`relative overflow-hidden py-28 md:py-36 bg-slate-50 text-center ${isSelected ? "ring-2 ring-blue-500 relative z-20" : ""}`}
      style={{
        fontFamily,
        background: `linear-gradient(135deg, ${primaryColor}05 0%, #ffffff 100%)`,
      }}
    >
      <div className="max-w-4xl mx-auto px-6 space-y-6">
        <h1 className="text-4xl md:text-6xl font-extrabold tracking-tight text-slate-900 leading-tight">
          <EditableText
            value={content.title || "Build Trust. Scale Fast."}
            onChange={(val) => updateContent("title", val)}
            as="span"
          />
        </h1>

        <p className="text-lg md:text-xl text-slate-650 max-w-2xl mx-auto leading-relaxed">
          <EditableText
            value={content.subtitle || "We provide enterprise-grade infrastructure for the world's leading companies."}
            onChange={(val) => updateContent("subtitle", val)}
            as="span"
          />
        </p>

        <div className="flex flex-wrap justify-center gap-4 pt-4">
          <a
            href={content.primaryBtnLink || "#demo"}
            className="px-6 py-3 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-bold text-sm shadow transition-all flex items-center gap-2"
          >
            {content.primaryCta || "Request Demo"}
            <PiArrowRight className="w-4 h-4" />
          </a>
          <a
            href={content.secondaryBtnLink || "#studies"}
            className="px-6 py-3 rounded-lg border border-slate-300 text-slate-700 hover:bg-slate-50 font-bold text-sm transition-all"
          >
            {content.secondaryCta || "Case Studies"}
          </a>
        </div>
      </div>
    </div>
  );
}
